export default [
  {
    model_type: 'specialproject',
    slug: '/collections/velikie-voenachalniki-i-razvedchiki',
    image: {
      preview: '/specprojects/razvedchiki-i-voenachalniki.png',
    },
    title: 'Великие военачальники и разведчики',
    announce:
      'Полководцы и мастера разведки, чьи решения, мужество и способности сыграли решающую роль в защите государства',
  },
  {
    model_type: 'specialproject',
    slug: '/collections/velikie-diplomaty-rossii',
    image: {
      preview: '/specprojects/diplomaty.png',
    },
    title: 'Великие дипломаты России',
    announce:
      'Выдающиеся государственные деятели, которые внесли значительный вклад в развитие внешней политики страны и укрепление её позиций на международной арене',
  },
  {
    model_type: 'specialproject',
    slug: '/collections/velikie-zakonotvorcy-rossii',
    image: {
      preview: '/specprojects/zakonotvorcy.png',
    },
    title: 'Великие законотворцы России',
    announce:
      'Выдающиеся деятели, которые сыграли ключевую роль в создании и развитии правовой системы страны, формируя законы, оказавшие влияние на государственное устройство и жизнь общества',
  },
];
